<template>
  <esg-base-dashboard-card title="온실가스 배출량 "
                           :subtitle="`(전사 - 법인 단위 - ${currentYear}년)`">
    <template #actions>
      <esg-base-select-box v-model="sort"
                           label="정렬"
                           size="sm">
        <option value="asc">오름차순</option>
        <option value="dsc">내림차순</option>
      </esg-base-select-box>
    </template>

    <!-- 전사 법인별 온실가스 배출량 -->
    <firmwide-emission-by-corp legend="bottom"
                               :sort="sort"
                               @dataPointSelection="onDataPointSelection"/>
    <!-- /전사 법인별 온실가스 배출량 -->

    <!-- 사업장별 온실가스 배출량 모달 - 전사 법인별 온실가스 배출량 데이터 선택 시 보임 -->
    <esg-base-dashboard-modal id="biz-loc-emission">
      <sortable-corp-emission-by-biz-loc :corporation="corporation"/>
    </esg-base-dashboard-modal>
    <!-- /사업장별 온실가스 배출량 모달 -->
  </esg-base-dashboard-card>
</template>

<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import FirmwideEmissionByCorp from "@/components/esg/3. Monitoring/charts2/FirmwideEmissionByCorp.vue";
import EsgBaseSelectBox from "@/components/esg/base/form/EsgBaseSelectBox.vue";
import SortableCorpEmissionByBizLoc
  from "@/components/esg/3. Monitoring/dashboardCards/SortableCorpEmissionByBizLoc.vue";
import EsgBaseDashboardModal from "@/components/esg/base/EsgBaseDashboardModal.vue";

export default {
  name: "SortableFirmwideEmissionByCorp",
  components: {
    EsgBaseDashboardModal,
    SortableCorpEmissionByBizLoc, EsgBaseSelectBox, FirmwideEmissionByCorp, EsgBaseDashboardCard
  },
  data() {
    return {
      sort: 'dsc',
      corporation: {},
    }
  },
  methods: {
    onDataPointSelection(corporation) {
      this.corporation = corporation;
      this.$bvModal.show("biz-loc-emission")
    },
  }
}
</script>